const apiSettings = {
  url: process.env.VUE_APP_API_URL
}

export default {
  apiSettings
}
